import {cssRule, style as cn, classes, keyframes, media} from 'typestyle';
import * as types from 'typestyle/lib/types';
import {TableRowBackgroundColor, BlueBackgroundColor, BlueColor, WhiteColor, BlackColorFaded20} from './colors';

cssRule('html, body, #main', {
    height: '100%',
});

cssRule('.recharts-wrapper', {
    '-webkit-user-select': 'none',
    '-moz-user-select': 'none',
    '-ms-user-select': 'none',
    userSelect: 'none',
});

export const spinner = (size, backgroundColor = BlackColorFaded20, spinnerColor = WhiteColor) => {
    return classes(
        spinnerClassName,
        cn({
            background: backgroundColor,
            $nest: {
                '&&::before': {
                    width: size,
                    height: size,
                    marginTop: size / -2,
                    marginLeft: size / -2,
                    borderTop: '2px solid ' + spinnerColor,
                },
            },
        })
    );
};

const spinnerAnimationName = keyframes({
    to: {
        transform: 'rotate(360deg)',
    },
});

const spinnerClassName = cn({
    position: 'absolute',
    background: BlackColorFaded20,
    zIndex: 30,
    textAlign: 'center',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    $nest: {
        '&::before': {
            content: "''",
            boxSizing: 'border-box',
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: 50,
            height: 50,
            marginTop: -25,
            marginLeft: -25,
            borderRadius: '50%',
            borderTop: '2px solid ' + WhiteColor,
            borderRight: '2px solid transparent',
            animationName: spinnerAnimationName,
            animationDuration: '.6s',
            animationIterationCount: 'infinite',
        },
    },
});

export const blueButtonClassName = cn({
    position: 'relative',
    verticalAlign: 'top',
    height: 30,
    border: 'none',
    backgroundColor: BlueColor,
    color: WhiteColor,
    $nest: {
        '&.disabled': {
            backgroundColor: BlueBackgroundColor,
        },
    },
});

export const mainContentClassName = cn({
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1,
    flex: '1',
    overflow: 'hidden',
    backgroundColor: WhiteColor,
});

export const evenRowClassName = cn({
    backgroundColor: WhiteColor,
});

export const oddRowClassName = cn({
    backgroundColor: TableRowBackgroundColor,
});

type MediaBreakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

// Values from material-ui
const MediaBreakpoints: {[key in MediaBreakpoint]: number} = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
};

export const mediaQuery = (min: MediaBreakpoint | '_', max: MediaBreakpoint | '_', style: types.NestedCSSProperties) =>
    media({minWidth: min === '_' ? undefined : MediaBreakpoints[min], maxWidth: max === '_' ? undefined : MediaBreakpoints[max]}, style);



// WEBPACK FOOTER //
// ./src/styles/style.ts